import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button,Input } from 'reactstrap';
import { connect } from 'react-redux';
import GraphicsQAImageDetails from './GraphicsQAImageDetails';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import UploadProjectDashImages from '../UploadProjectDashAssets/UploadProjectDashImages';
import { faTrash, faTimes, faAngleDown, faAngleUp, faCloudUploadAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BackButton from '../../../../../../../../designUtils/Logo/BackButton.svg'
import ClearFilters from '../../../../../../../../designUtils/ProjectDashboard/ClearFilters.svg'; 

function ProjectDashGraphicQA(props) {
    const { selectedASIN } = props;
  // const [selectedImage, props.setSelectedImage] = useState(props.fileList && props.fileList.length > 0 ? props.fileList[0] : '');
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showUploadComponent, setShowUploadComponent] = useState(false);
  const [loadScreen, setLoadScreen] = useState(false);
  const [statusTexts,setStatusTexts]=useState()
  const [statusFilter, setStatusFilter] = useState('All');
  const [searchGraphics, setSearchGraphics] = useState('');
  const [destinationSubCategories, setDestinationSubCategories] = useState('');
  const [filteredStatus,setFilteredStatus]=useState()
  const handleUpdateImage = (updatedImage) => {
    props.setSelectedImage(updatedImage);
    props.setFileList((prev) =>
      prev.map((file) =>
        file.id === updatedImage.id ? updatedImage : file
      )
    );
  };

 
  const handleStatusFilter=(data)=>{
    console.log(data)
    setFilteredStatus(data)
  }

  const handleBackFromUploadAssets = () => {
    setShowUploadComponent(false);
    // After upload, select the first image if none selected
    setTimeout(() => {
      if(props.fileList && props.fileList.length > 0) {
        props.setSelectedImage(props.fileList[0]);
      }
    }, 100);
  };

  const handleClearFilters = () => {
    setSearchGraphics('');
    setDestinationSubCategories('');
    setStatusFilter('All');
    handleStatusFilter('All');

    setTimeout(() => {
      const newFilteredFiles = props.fileList.filter(file => {
        return true; 
      });

      if (newFilteredFiles.length > 0) {
        props.setSelectedImage(newFilteredFiles[0]);
      } else {
        props.setSelectedImage(null);
      }
    }, 0);
  };

  const filteredFiles = props.fileList.filter(file => {
    // Version children stay bunched under the original (parentAssetId != own id).
    if (file.parentAssetId && String(file.parentAssetId) !== String(file.id)) {
      return false;
    }
    
    const query = searchGraphics.toLowerCase().trim();
  
    const matchesSearch =
        !query ||
        (file.actualFileName && file.actualFileName.toLowerCase().includes(query)) ||
        (file.asinList && file.asinList.toLowerCase().includes(query)) ||
        (file.id && file.id.toString().includes(query)) ||
        (file.amazonPosition && `#${file.amazonPosition}`.includes(query));
        
      const matchesDestination =
          !destinationSubCategories ||
          (file.destinationSubCategoriesId != null &&
          file.destinationSubCategoriesId.toString() === destinationSubCategories);

    // Check if parent itself or ANY of its versions match the status filter
    const parentMatchesStatus =
      (file.statusText || '').toLowerCase() === statusFilter.toLowerCase();
    const anyVersionMatchesStatus =
      (file.versionAssets || []).some(v => (v.statusText || '').toLowerCase() === statusFilter.toLowerCase());
    const matchesStatus =
      statusFilter === 'All' || parentMatchesStatus || anyVersionMatchesStatus;

    return matchesStatus && matchesSearch && matchesDestination;
  });  

  useEffect(()=>{
    if(filteredFiles) {
        if(!props.selectedImage && filteredFiles.length > 0) {
            console.log('Setting initial selected image from filter')
            props.setSelectedImage(filteredFiles[0])
        } else if (props.selectedImage) {
            const currentImageStillExists = filteredFiles.find(file => file.id === props.selectedImage.id);
            if(!currentImageStillExists) {
                console.log('Current selected image no longer exists in filter, selecting first')
                props.setSelectedImage(filteredFiles.length > 0 ? filteredFiles[0] : null)
            }
        }
    }
  }, [props.fileList, props.selectedImage, searchGraphics, destinationSubCategories, statusFilter])
 
  // const statusOptions = [{ text: 'All' }, ...Object.values(props.fileStatus || {})];
  // Graphics QA statuses (assetSubCategory_id = 7), ordered by sequence
  const statusSequence = [
    'All',
    'New',
    'Internal Revision',
    'Internal Approved',
    'Sent for Approval',
    'Approved',
    'Paused',
    'Partner Revision',
    'Moved to Assets Gallery',
  ];
  
  const statusOptions = statusSequence.map(status => ({
    text: status,
    count: status === 'All'
      ? Object.values(props.assetsStatusCount || {}).reduce((sum, c) => sum + c, 0)
      : (props.assetsStatusCount && props.assetsStatusCount[status]) || 0
  }));


  if (showUploadComponent) {
    return (
      <UploadProjectDashImages
      setSelectedASIN={props.setSelectedASIN}
      selectedProjectData={props.selectedProjectData}
        selectedSubCategories={props.selectedSubCategories}
        assetCategory={props.selectedSubCategories.id}
        subCategoryId={props.selectedSubCategories.id}
        handleBackFromUploadAssets={handleBackFromUploadAssets}
        setAssetsStatusCount={props.setAssetsStatusCount}
        setAsinAssetCounts={props.setAsinAssetCounts}
        // assetIdentifier={props.selectedASIN}
        selectedASIN={props.selectedASIN}
        assetIdentifier={props.selectedProjectData.brand}
        setFileList={props.setFileList}
        existingSubCategories={props.filterSubcategoryList}
        onUpdateImage={handleUpdateImage}
        setAllOriginalFiles={props.setAllOriginalFiles}
        allOriginalFiles={props.allOriginalFiles}
      />
    );
  }
  return (
    <>
      <LoadingOverlay
        active={loadScreen}
        styles={{
          overlay: (base) => ({
            ...base,
            background: '#f1f4f6',
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: '#000',
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text="Loading Assets..."
      >
        <Row className="align-items-center mb-1">
        <Col md={3} className="d-flex align-items-center mt-3">
          <h6>
            <button onClick={() =>props.setSelectedASIN(null)} className=" back-btn mr-1 "  >
              <img src={BackButton} alt="not found" />
            </button>
            &nbsp;<b>{props.selectedASIN}</b>
          </h6>
        </Col>
        <Col md={3}>
            <select
              className="form-control"
              value={destinationSubCategories}
              onChange={(e) => {
                const selectedValue = e.target.value;
                setDestinationSubCategories(selectedValue);
                
                setTimeout(() => {
                  const newFilteredFiles = props.fileList.filter(file => {
                    if (file.parentAssetId && String(file.parentAssetId) !== String(file.id)) return false;
                    const matchesStatus =
                      statusFilter === 'All' ||
                      (file.statusText || '').toLowerCase() === statusFilter.toLowerCase();
                    
                    const query = searchGraphics.toLowerCase().trim();
                    
                    const matchesSearch =
                        !query ||
                        (file.actualFileName && file.actualFileName.toLowerCase().includes(query)) ||
                        (file.asinList && file.asinList.toLowerCase().includes(query)) ||
                        (file.id && file.id.toString().includes(query)) ||
                        (file.amazonPosition && `#${file.amazonPosition}`.includes(query));
                        
                    const matchesDestination =
                        !selectedValue ||
                        (file.destinationSubCategoriesId != null &&
                        file.destinationSubCategoriesId.toString() === selectedValue);
                    
                    return matchesStatus && matchesSearch && matchesDestination;
                  });
                  
                  const isCurrentSelectedValid = props.selectedImage && newFilteredFiles.some(f => f.id === props.selectedImage.id);
                  if (!isCurrentSelectedValid) {
                    if (newFilteredFiles.length > 0) {
                      props.setSelectedImage(newFilteredFiles[0]);
                    } else {
                      props.setSelectedImage(null);
                    }
                  }
                }, 0);
              }}
              style={{color: destinationSubCategories === '' ? '#6c757d' : '#000'}}
            >
            <option value="">--Destination Category--</option>
                  {props.filterSubcategoryList &&
                    props.filterSubcategoryList.map((subCategory) => (
                      <option key={subCategory.id} value={subCategory.id}>
                        {subCategory.subCategoryName}
                        {" "}
                        ({subCategory.assetCategory__categoryName})
                      </option>
                    ))}
          </select>
        </Col>
        <Col md={3}>
        <Input
          placeholder="Search by Id or Amazon No. or File Name"
          className="w-100"
          style={{ color: searchGraphics === '' ? '#6c757d' : '#000' }}
          value={searchGraphics}
          onChange={(e) => {
            const searchValue = e.target.value;
            setSearchGraphics(searchValue);
            
            setTimeout(() => {
              const newFilteredFiles = props.fileList.filter(file => {
                if (file.parentAssetId && String(file.parentAssetId) !== String(file.id)) return false;
                const matchesStatus =
                  statusFilter === 'All' ||
                  (file.statusText || '').toLowerCase() === statusFilter.toLowerCase();
                
                const query = searchValue.toLowerCase().trim();
                
                const matchesSearch =
                    !query ||
                    (file.actualFileName && file.actualFileName.toLowerCase().includes(query)) ||
                    (file.asinList && file.asinList.toLowerCase().includes(query)) ||
                    (file.id && file.id.toString().includes(query)) ||
                    (file.amazonPosition && `#${file.amazonPosition}`.includes(query));
                    
                const matchesDestination =
                    !destinationSubCategories ||
                    (file.destinationSubCategoriesId != null &&
                    file.destinationSubCategoriesId.toString() === destinationSubCategories);
                
                return matchesStatus && matchesSearch && matchesDestination;
              });
              
              const isCurrentSelectedValid = props.selectedImage && newFilteredFiles.some(f => f.id === props.selectedImage.id);
              if (!isCurrentSelectedValid) {
                if (newFilteredFiles.length > 0) {
                  props.setSelectedImage(newFilteredFiles[0]);
                } else {
                  props.setSelectedImage(null);
                }
              }
            }, 0);
          }}
          />
        </Col>
        <Col md={1} className="d-flex justify-content-start align-items-center mt-1">
                <img
                  src={ClearFilters}
                  onClick={handleClearFilters}
                  style={{ cursor: 'pointer' }}
                  alt="Clear Filters"
                  title="Clear Filters"
                />
              </Col>
        <Col md={2} className="d-flex justify-content-end">
          <Button
            className="btn-background-color-Proceed-gallery w-100"
            onClick={() => setShowUploadComponent(true)}
          >
            Upload Assets
          </Button>
        </Col>
      </Row>
      <Row className="mb-4 align-items-center">
    <Col md={12} className="d-flex flex-wrap align-items-center">
      {statusOptions.map((item, index) => {
        // Calculate count for this status
        const statusCount = item.text === 'All' 
          ? Object.values(props.assetsStatusCount || {}).reduce((sum, count) => sum + count, 0)
          : (props.assetsStatusCount && props.assetsStatusCount[item.text]) || 0;
        
        return ( // Added explicit return
          <div key={index} className="status-radio-wrapper">
            <label
              htmlFor={item.text}
              className={`status-radio-label ${item.text.replace(/\s+/g, '-')} ${statusFilter === item.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                id={item.text}
                name="statusFilter"
                value={item.text}
                checked={statusFilter === item.text}
                onChange={(e) => {
                  const selectedValue = e.target.value; 
                  setStatusFilter(selectedValue);
                  handleStatusFilter(selectedValue);
                  setTimeout(() => {
                    const newFilteredFiles = props.fileList.filter(file => {
                      if (file.parentAssetId && String(file.parentAssetId) !== String(file.id)) {
                        return false;
                      }

                      const query = searchGraphics.toLowerCase().trim();
                      
                      const matchesSearch =
                          !query ||
                          (file.actualFileName && file.actualFileName.toLowerCase().includes(query)) ||
                          (file.asinList && file.asinList.toLowerCase().includes(query)) ||
                          (file.id && file.id.toString().includes(query)) ||
                          (file.amazonPosition && `#${file.amazonPosition}`.includes(query));
                          
                      const matchesDestination =
                          !destinationSubCategories ||
                          (file.destinationSubCategoriesId != null &&
                          file.destinationSubCategoriesId.toString() === destinationSubCategories);
                      
                      const parentMatchesStatus =
                        (file.statusText || '').toLowerCase() === selectedValue.toLowerCase();
                      const anyVersionMatchesStatus =
                        (file.versionAssets || []).some(v => (v.statusText || '').toLowerCase() === selectedValue.toLowerCase());
                      const matchesStatus =
                        selectedValue === 'All' || parentMatchesStatus || anyVersionMatchesStatus;

                      return matchesStatus && matchesSearch && matchesDestination;
                    });
                    if (newFilteredFiles.length > 0) {
                      props.setSelectedImage(newFilteredFiles[0]);
                    } else {
                      props.setSelectedImage(null);
                    }
                  }, 0);
                }}
              />
              <span className="mr-2"></span>
              {item.text}
              <b 
              className="assetsStatusCount" 
              style={{
                minWidth: `${Math.max(16, statusCount.toString().length * 10)}px`,
                minHeight: `${Math.max(16, statusCount.toString().length * 10)}px`,
                padding: `4px ${Math.max(6, statusCount.toString().length * 3)}px`
              }}
            >
              {statusCount}
            </b>
             
            </label>
          </div>
        ); // Closing return parenthesis
      })}
    </Col>
  </Row>

      <Row>
  {filteredFiles && filteredFiles.length > 0 ? (
    <GraphicsQAImageDetails
    setAssetsStatusCount={props.setAssetsStatusCount}
      selectedImage={props.selectedImage}
      setSelectedImage={props.setSelectedImage}
      selectedStatus={selectedStatus}
      setAsinAssetCounts={props.setAsinAssetCounts}
      setSelectedASIN={props.setSelectedASIN}
      selectedASIN={props.selectedASIN}
      setSelectedStatus={setSelectedStatus}
      onClose={() => props.setSelectedASIN(null)}
      setAllOriginalFiles={props.setAllOriginalFiles}
      allOriginalFiles={props.allOriginalFiles}
      file={filteredFiles}
      loggedInUser={props.loggedInUser}
      projectPermissions={props.projectPermissions}
      setFileList={props.setFileList}
      selectedProjectData={props.selectedProjectData}
      selectedSubCategories={props.selectedSubCategories}
      setFileListOfAssets={props.setFileList}
      subCategoryId={props.selectedSubCategories.id}
      assetCategory={props.selectedSubCategories.assetCategory}
      // assetIdentifier={props.selectedASIN}
      asinList={props.selectedASIN}
      assetIdentifier={props.selectedProjectData.brand}
      existingSubCategories={props.filterSubcategoryList}
      statusTexts={statusTexts}
      statusFilter={statusFilter}
    />
  ) : (
    <Col md={12}>
    <div className="no-images-wrapper" style={{ position: "relative", minHeight: "200px" }}>
      {/* Close Button at Top Right */}
      <button
        className="card-close-button"
        title="Close"
        onClick={() => props.setSelectedASIN(null)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: "18px",
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
  
      {/* Message in Center */}
      <Row className="justify-content-center align-items-center" style={{ minHeight: "200px" }}>
        <Col md={12} className="text-center mt-5">
          <div className="no-images-container" style={{ padding: "50px 20px" }}>
            <h4 style={{ color: "#666", marginBottom: "10px" }}>No Graphics Available</h4>
          </div>
        </Col>
      </Row>
    </div>
    </Col>
  )}
</Row>



      </LoadingOverlay>
    </>
  );
}

const mapStateToProps = (state) => ({
    storeOverview: state.accountOverview.store.storeOverview,
    token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,

});
export default connect(mapStateToProps)(ProjectDashGraphicQA);
